import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import './index.css';
import App from './App.tsx';

// Initialize Sentry before React mounts so early errors are captured too.
// Only init when a DSN is provided via env (keeps local dev quiet).
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    // Strip email + auth tokens before sending.
    beforeSend(event) {
      if (event.request?.headers) {
        delete event.request.headers.Authorization;
        delete event.request.headers.authorization;
      }
      return event;
    },
  });

  // Expose to window so the existing ErrorBoundary's captureException
  // hook (`window.Sentry.captureException`) continues to work without
  // importing Sentry into every leaf component.
  (window as unknown as { Sentry: typeof Sentry }).Sentry = Sentry;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
